import { createReducer, on } from '@ngrx/store';
import { InjectionToken } from '@angular/core';
import { AuthenticationActions } from './authentication.action-types';
import { NumberOrEmpty, StringOrEmpty } from 'src/app/app.model';

export interface AuthenticationState {
  idToken: StringOrEmpty;
  accessToken: StringOrEmpty;
  expiresAt: NumberOrEmpty | StringOrEmpty;
  authProviderId: StringOrEmpty;
  isLoggedIn: boolean;
  error: StringOrEmpty;
}

const initialAuthenticationState: AuthenticationState = {
  idToken: null,
  accessToken: null,
  expiresAt: null,
  authProviderId: null,
  isLoggedIn: false,
  error: null,
};

export const authenticationReducer = createReducer(
  initialAuthenticationState,

  on(AuthenticationActions.Authenticated, (state, action) => {
    return {
      ...state,
      idToken: action.auth.idToken,
      accessToken: action.auth.accessToken,
      expiresAt: action.auth.expiresAt,
      authProviderId: action.auth.authProviderId || action.auth.idTokenPayload?.sub,
      isLoggedIn: true,
    };
  }),

  on(AuthenticationActions.Logout, (state, action) => {
    return {
      ...initialAuthenticationState,
    };
  }),
  on(AuthenticationActions.LogoutSuccess, (state) => {
    return state;
  }),
);
